<main class="bg-black text-white min-h-screen overflow-x-hidden">
  <section class="relative min-h-[65vh] flex items-center pt-24 pb-14 overflow-hidden page-hero-gradient">
    <div class="absolute -top-48 right-0 w-[700px] h-[700px] bg-varroc-accent/5 rounded-full blur-3xl"></div>
    <div class="relative  flex flex-col sm:flex-row items-center z-10 max-w-7xl mx-auto px-6 w-full">
      <div class="w-full sm:w-1/2">
        <a routerLink="/products/hardware" class="back-nav" data-aos="fade-down">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 svg-stroke-gradient">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
          Back to Hardware
        </a>
        <h1 class="hero-col font-black" data-aos="fade-up" data-aos-delay="100">
          Hiker by Varroc presents <span class="text-varroc-accent">Camzo</span>
        </h1>
        <h4 class="text-varroc-text-gray mb-5">A smart eye for every smart driving.</h4>
        <p class="text-varroc-text-gray text-lg leading-relaxed mb-8 max-w-3xl" data-aos="fade-up" data-aos-delay="200">
          Dual-camera smart dashcam with 2K front + 1K rear recording, Wi-Fi app access, live view, playback, trip
          reports, contextual alerts, and connected support through the Varroc Connect App.</p>
        <div class="flex flex-wrap gap-3 mb-8" data-aos="fade-up" data-aos-delay="250">
          <span class="px-3 py-1.5 rounded-full bg-varroc-dark border border-varroc-border text-sm text-white">2K Front
            + 1K Rear</span>
          <span class="px-3 py-1.5 rounded-full bg-varroc-dark border border-varroc-border text-sm text-white">130° Wide
            Angle</span>
          <span class="px-3 py-1.5 rounded-full bg-varroc-dark border border-varroc-border text-sm text-white">Wi-Fi App
            Access</span>
          <!-- <span class="px-3 py-1.5 rounded-full bg-varroc-dark border border-varroc-border text-sm text-white">Up to 256GB</span> -->
        </div>
        <div class="flex flex-wrap gap-4" data-aos="fade-up" data-aos-delay="300">
          <a [href]="androidAppLink" target="_blank" rel="noopener noreferrer"
            class="bg-varroc-accent text-white font-bold px-8 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all hiker_by_varroc_cam_zo_smart_dashcam_download_app_button">Download
            App</a>
          <a (click)="scrollTo('setup')"
            class="border border-varroc-accent/40 font-semibold px-8 py-4 rounded-md hover:border-varroc-accent hover:bg-varroc-accent transition-all cursor-pointer hiker_by_varroc_cam_zo_smart_dashcam_setup_guide_button">Setup
            Guide</a>
          <button type="button"
            class="border border-varroc-accent/40 font-semibold px-8 py-4 rounded-md hover:border-varroc-accent hover:bg-varroc-accent transition-all cursor-pointer hiker_by_varroc_cam_zo_smart_dashcam_notify_me_button"
            routerLink="/store/product/camzo">
            Buy Now
          </button>

        </div>
      </div>
      <div class="w-full sm:w-1/2 cursor-pointer" routerLink="/store/product/camzo">
        <img src="../../../../../assets/images/storev2/camzo-dashcam/camzo-launch-banner.jpg" alt="">
      </div>
    </div>
  </section>

  <nav class="sticky-product-nav">
    <div class="max-w-7xl mx-auto px-6">
      <div class="flex overflow-x-auto">
        <a *ngFor="let s of sections" (click)="scrollTo(s.id)" [class.active]="activeSection === s.id"
          class="cursor-pointer flex-shrink-0"><i class='bx text-base' [class]="s.icon"></i> {{ s.label }}</a>
      </div>
    </div>
  </nav>

  <div class="max-w-7xl mx-auto px-6 py-20 space-y-28">
    <section id="overview" class="section-anchor">
      <div class="text-center mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Overview</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Dashcam Essentials at a Glance</h2>
        <p class="text-varroc-text-gray text-lg max-w-3xl mx-auto">This dashcam combines dual-camera recording, app
          connectivity, trip visibility, and contextual alerts in one setup flow designed for everyday driving.</p>
      </div>
      <div class="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        <div *ngFor="let s of specs; let i = index" class="feature-card" [attr.data-aos]="'fade-up'"
          [attr.data-aos-delay]="(i * 60).toString()">
          <div class="text-varroc-text-gray text-xs uppercase tracking-widest mb-1">{{ s.label }}</div>
          <div class="text-white font-bold leading-snug">{{ s.value }}</div>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <section id="setup" class="section-anchor">
      <div class="text-center mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Setup</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Install the App and Connect the Dashcam</h2>
      </div>
      <div class="grid lg:grid-cols-2 gap-6">
        <div class="feature-card p-8" data-aos="fade-right">
          <div class="flex items-center gap-3 mb-5">
            <div class="w-12 h-12 rounded-xl bg-varroc-accent/15 flex items-center justify-center"><i
                class='bx bx-mobile icon-gradient text-2xl'></i></div>
            <div>
              <div class="text-white font-bold text-xl">Install Varroc Connect App</div>
              <div class="text-varroc-text-gray text-sm">Begin with app download and device onboarding.</div>
            </div>
          </div>
          <ol class="space-y-3 text-varroc-text-gray list-decimal list-inside">
            <li *ngFor="let step of installSteps">{{ step }}</li>
          </ol>
          <div class="flex flex-wrap gap-2 mt-6">
            <span *ngFor="let action of installActions"
              class="px-3 py-1 rounded-full border border-varroc-border bg-varroc-dark text-white text-sm">{{ action
              }}</span>
          </div>
          <div class="flex flex-wrap gap-4 mt-6">
            <a [href]="androidAppLink" target="_blank" rel="noopener noreferrer"
              class="bg-varroc-accent text-white font-semibold px-5 py-3 rounded-md hover:bg-varroc-accent-hover transition-all">Google
              Play Store</a>
            <a [href]="iosAppLink" target="_blank" rel="noopener noreferrer"
              class="border border-varroc-accent/40 px-5 py-3 rounded-md font-semibold hover:border-varroc-accent hover:bg-varroc-accent/10 transition-all">Apple
              App Store</a>
          </div>
        </div>

        <div class="feature-card p-8" data-aos="fade-left">
          <div class="flex items-center gap-3 mb-5">
            <div class="w-12 h-12 rounded-xl bg-varroc-accent/15 flex items-center justify-center"><i
                class='bx bx-wifi icon-gradient text-2xl'></i></div>
            <div>
              <div class="text-white font-bold text-xl">Connect Dashcam via Wi-Fi</div>
              <div class="text-varroc-text-gray text-sm">Use the default Wi-Fi credentials during first pairing.</div>
            </div>
          </div>
          <ol class="space-y-3 text-varroc-text-gray list-decimal list-inside">
            <li *ngFor="let step of wifiSteps">{{ step }}</li>
          </ol>
          <div class="mt-6 rounded-xl border border-varroc-border bg-varroc-dark/70 p-4">
            <div class="text-white font-semibold mb-1">Default Password</div>
            <div class="text-varroc-accent font-bold tracking-wide">12345678</div>
          </div>
        </div>
      </div>
      <div class="grid md:grid-cols-2 gap-6 mt-6">
        <div class="feature-card" data-aos="fade-up" data-aos-delay="60">
          <div class="text-white font-bold mb-2">Varroc Miles</div>
          <p class="text-varroc-text-gray text-sm leading-relaxed">Earn rewards for safe driving through the connected
            experience inside the app.</p>
        </div>
        <div class="feature-card" data-aos="fade-up" data-aos-delay="120">
          <div class="text-white font-bold mb-2">E-commerce Access</div>
          <p class="text-varroc-text-gray text-sm leading-relaxed">Access offers and services in-app without leaving the
            Varroc Connect ecosystem.</p>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <section id="app" class="section-anchor">
      <div class="text-center mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">App Features</span>
        <h2 class="text-4xl font-black mt-2 mb-4">What You Can Do in the App</h2>
      </div>
      <div class="grid md:grid-cols-2 xl:grid-cols-3 gap-5">
        <div *ngFor="let feature of appFeatures; let i = index" class="feature-card" [attr.data-aos]="'fade-up'"
          [attr.data-aos-delay]="(i * 60).toString()">
          <div class="w-11 h-11 rounded-lg bg-varroc-accent/15 flex items-center justify-center mb-4">
            <i class='bx icon-gradient text-xl' [class]="feature.icon"></i>
          </div>
          <div class="text-white font-bold mb-2">{{ feature.title }}</div>
          <p class="text-varroc-text-gray text-sm leading-relaxed">{{ feature.desc }}</p>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <section id="troubleshooting" class="section-anchor">
      <div class="text-center mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Troubleshooting</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Quick Checks Before Support</h2>
      </div>
      <div class="grid lg:grid-cols-[1.4fr,0.6fr] gap-6">
        <div class="grid md:grid-cols-2 gap-5">
          <div *ngFor="let item of troubleshooting; let i = index" class="feature-card" [attr.data-aos]="'fade-up'"
            [attr.data-aos-delay]="(i * 60).toString()">
            <div class="text-white font-bold mb-2">{{ item.issue }}</div>
            <p class="text-varroc-text-gray text-sm leading-relaxed">{{ item.fix }}</p>
          </div>
        </div>
        <div class="feature-card p-8" data-aos="fade-left">
          <div class="text-white font-bold text-xl mb-4">LED Status Indicators</div>
          <div class="space-y-4">
            <div *ngFor="let led of ledIndicators"
              class="flex items-start justify-between gap-4 border-b border-varroc-border pb-4 last:border-b-0 last:pb-0">
              <div>
                <div class="text-white font-semibold">{{ led.color }} LED</div>
                <div class="text-varroc-text-gray text-sm">{{ led.status }}</div>
              </div>
              <div class="text-varroc-accent font-semibold text-right">{{ led.meaning }}</div>
            </div>
          </div>
          <p class="text-varroc-text-gray text-sm leading-relaxed mt-6">Wi-Fi connection state is indicated inside the
            app during pairing and usage.</p>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <section id="safety" class="section-anchor">
      <div class="grid lg:grid-cols-[1.2fr,0.8fr] gap-6 items-start">
        <div>
          <div class="mb-8" data-aos="fade-up">
            <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Safety & Usage</span>
            <h2 class="text-4xl font-black mt-2 mb-4">Important Usage Notes</h2>
            <p class="text-varroc-text-gray text-lg max-w-2xl">Use the dashcam as an assistive aid only and keep the
              device, SD card, and app maintained for reliable operation.</p>
          </div>
          <div class="grid gap-4">
            <div *ngFor="let tip of safetyTips; let i = index" class="feature-card flex items-start gap-4"
              [attr.data-aos]="'fade-up'" [attr.data-aos-delay]="(i * 50).toString()">
              <i class='bx bx-check-shield icon-gradient text-xl mt-0.5'></i>
              <p class="text-varroc-text-gray text-sm leading-relaxed">{{ tip }}</p>
            </div>
          </div>
          <p class="text-varroc-text-gray text-sm mt-6">Note: Dashcam is an assistive aid only.</p>
        </div>
        <div class="feature-card p-8" data-aos="fade-left">
          <div class="text-white font-bold text-2xl mb-3">Support & Next Steps</div>
          <p class="text-varroc-text-gray text-sm leading-relaxed mb-6">For best experience, keep the app updated. For
            installation questions and technical support, contact our support team.</p>
          <div class="space-y-3 mb-6">
            <div class="flex items-center gap-3 text-white"><i class='bx bx-envelope icon-gradient text-xl'></i> <a
                [href]="'mailto:' + supportEmail" class="hover:text-varroc-accent transition">{{ supportEmail }}</a>
            </div>
            <div class="flex items-center gap-3 text-white"><i class='bx bx-qr-scan icon-gradient text-xl'></i>
              <span>Scan here to download the app and switch it on.</span>
            </div>
          </div>
          <div class="flex flex-col sm:flex-row gap-3">
            <a [href]="androidAppLink" target="_blank" rel="noopener noreferrer"
              class="bg-varroc-accent text-white font-bold px-5 py-3 rounded-md hover:bg-varroc-accent-hover transition-all text-center">Download
              App</a>
            <a routerLink="/contact-us"
              class="border border-varroc-accent/40 font-semibold px-5 py-3 rounded-md hover:border-varroc-accent hover:bg-varroc-accent/10 transition-all text-center">Contact
              Support</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</main>

<dialog #notifyDialog
  class="notify-dialog fixed inset-0 m-auto w-[calc(100%-2rem)] max-w-xl max-h-[calc(100dvh-2rem)] overflow-y-auto rounded-2xl border border-white/10 bg-[#05070b] shadow-[0_24px_70px_rgba(0,0,0,0.6)] px-5 py-6 text-white sm:px-7 sm:py-7"
  aria-label="Pre booking of Camzo is available" (cancel)="$event.preventDefault(); closeNotifyMeModal()">
  <div class="flex justify-end">
    <button type="button" class="text-white/80 hover:text-white text-3xl leading-none" aria-label="Close notify form"
      (click)="closeNotifyMeModal()">
      x
    </button>
  </div>

  <form (ngSubmit)="submitNotifyMe()" class="mt-2">
    <div class="mb-5">
      <label for="dashcamNotifyName" class="block text-white/90 text-lg mb-2">Name</label>
      <input id="dashcamNotifyName" name="notifyName" type="text" [(ngModel)]="notifyForm.name"
        placeholder="Enter your name"
        class="w-full rounded-lg bg-[#0b0f15] border border-white/10 px-4 py-3 text-white placeholder:text-white/40 focus:outline-none focus:ring-1 focus:ring-varroc-accent" />
    </div>

    <div class="mb-5">
      <label for="dashcamNotifyEmail" class="block text-white/90 text-lg mb-2">Email</label>
      <input id="dashcamNotifyEmail" name="notifyEmail" type="email" [(ngModel)]="notifyForm.email"
        placeholder="Enter your email"
        class="w-full rounded-lg bg-[#0b0f15] border border-white/10 px-4 py-3 text-white placeholder:text-white/40 focus:outline-none focus:ring-1 focus:ring-varroc-accent" />
      <p *ngIf="isNotifyEmailInvalid()" class="mt-2 text-xs text-red-400">
        Please enter a valid email address.
      </p>
    </div>

    <div class="mb-8">
      <label for="dashcamNotifyPhone" class="block text-white/90 text-lg mb-2">Phone No.</label>
      <div class="flex gap-2">
        <div class="rounded-lg bg-[#0b0f15] border border-white/10 px-3 py-3 text-white/90 min-w-[54px] text-center">+91
        </div>
        <input id="dashcamNotifyPhone" name="notifyPhone" type="tel" [(ngModel)]="notifyForm.phone"
          (input)="onNotifyPhoneInput()" inputmode="numeric" maxlength="10" minlength="10" pattern="[0-9]{10}"
          placeholder="Enter 10-digit mobile number"
          class="w-full rounded-lg bg-[#0b0f15] border border-white/10 px-4 py-3 text-white placeholder:text-white/40 focus:outline-none focus:ring-1 focus:ring-varroc-accent" />
      </div>
      <p *ngIf="isNotifyPhoneInvalid()" class="mt-2 text-xs text-red-400">
        Please enter a valid 10-digit mobile number.
      </p>
    </div>

    <button type="submit" [disabled]="!isNotifyFormValid() || isSubmittingNotify || isNotifySubmitSuccess"
      class="w-full bg-varroc-accent text-white py-3 rounded-lg text-xl font-medium hover:brightness-110 transition disabled:opacity-60 disabled:cursor-not-allowed">
      {{ isSubmittingNotify ? 'Submitting...' : 'Submit' }}
    </button>

    <p *ngIf="isNotifySubmitSuccess" class="mt-3 text-center text-sm text-emerald-300">
      {{ notifyToastMessage }}
    </p>
  </form>
</dialog>